var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 34,
    viewBox: "0 0 62 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 34,
    rx: 14,
    fill: "#8146FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 54,
    height: 26,
    rx: 11,
    fill: "#27292F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3926 22.3388V17.979C29.3926 17.4267 29.8403 16.979 30.3926 16.979H31.4741C32.0263 16.979 32.4741 17.4267 32.4741 17.979V22.9791C32.4741 23.7538 31.6312 24.2343 30.9646 23.8396L29.8831 23.1993C29.579 23.0192 29.3926 22.6921 29.3926 22.3388Z",
    fill: "#A1A3B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9622 11.5319L29.0636 18.0617C29.2465 18.353 29.5664 18.5298 29.9104 18.5298H31.9563C32.3003 18.5298 32.6201 18.353 32.8031 18.0617L36.9045 11.5319C37.3228 10.8659 36.8441 10 36.0577 10H25.809C25.0226 10 24.5439 10.8659 24.9622 11.5319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterMobile);
export default __webpack_public_path__ + "static/media/filter_mobile.6e184a7c9b2f750d7957e3d124798af2.svg";
export { ForwardRef as ReactComponent };